import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { SelfTruncatingPathModule } from '@portal-core/general/components/self-truncating-path/self-truncating-path.module';
import { PluralizeModule } from '@portal-core/general/pipes/pluralize/pluralize.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { WorkspaceFileGitStatusModule } from '@portal-core/workspaces/components/workspace-file-git-status/workspace-file-git-status.module';
import { CollabPullDialogComponent } from './collab-pull-dialog.component';

@NgModule({
  declarations: [
    CollabPullDialogComponent
  ],
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    LicenseUserAvatarModule,
    LoaderModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    PluralizeModule,
    SelfTruncatingPathModule,
    WorkspaceFileGitStatusModule
  ],
  exports: [
    CollabPullDialogComponent
  ]
})
export class CollabPullDialogModule { }
